<template>
  <section class="menu-admin" :class="{ 'open' : open }">
    <div class="menu-header">
      <div @click="push('/')" class="menu-logo">
        <img src="img/swiss.png">
      </div>
      <div @click="open = !open" class="menu-icon">
        <transition name="pop" mode="out-in">
          <i v-if="open" class="fas fa-times"></i>
          <i v-else class="fas fa-bars"></i>
        </transition>
      </div>
    </div>
    <div class="menu-items">
      <div @click="push('/analytics')" class="menu-item" :class="{ 'active' : isRoute('/analytics') }">
        <i class="fas fa-chart-line"></i>
        <span>Analytics</span>
      </div>
      <div @click="push('/transaction')" class="menu-item" :class="{ 'active' : isRoute('/transaction') }">
        <i class="fas fa-dollar-sign"></i>
        <span>Faturamento</span>
      </div>
      <!-- <div @click="push('/event-dates')" class="menu-item" :class="{ 'active' : isRoute('/analytics') }">
        <i class="fas fa-calendar-alt"></i>
        <span>Agenda</span>
      </div>
      <div @click="push('/showcase')" class="menu-item" :class="{ 'active' : isRoute('/showcase') }">
        <i class="fas fa-object-group"></i>
        <span>Vitrine</span>
      </div> -->
      <div @click="push('/product')" class="menu-item" :class="{ 'active' : isRoute('/product') }">
        <i class="fas fa-gift"></i>
        <span>Produtos</span>
      </div>
      <div @click="push('/educational-video')" class="menu-item" :class="{ 'active' : isRoute('/educational-video') }">
        <i class="fas fa-graduation-cap"></i>
        <span>Educacional</span>
      </div>
      <div @click="push('/customer')" class="menu-item" :class="{ 'active' : isRoute('/customer') }">
        <i class="fas fa-user-friends"></i>
        <span>Clientes</span>
      </div>
      <div @click="push('/signature')" class="menu-item" :class="{ 'active' : isRoute('/signature') }">
        <i class="fas fa-handshake"></i>
        <span>Assinaturas</span>
      </div>
      <div v-if="user.id === 1 || user.id === 5" @click="push('/courtesy')" class="menu-item" :class="{ 'active' : isRoute('/courtesy') }">
        <i class="fas fa-gift"></i>
        <span>Cortesias/Testes</span>
      </div>
      <!-- <div @click="push('/business')" class="menu-item" :class="{ 'active' : isRoute('/business') }">
        <i class="far fa-building"></i>
        <span>Estabelecimentos</span>
      </div> -->
      <div @click="push('/updates')" class="menu-item" :class="{ 'active' : isRoute('/updates') }">
        <i class="far fa-calendar-check"></i>
        <span>Atualizações</span>
      </div>
      <div @click="push('/log')" class="menu-item" :class="{ 'active' : isRoute('/log') }">
        <i class="fas fa-list"></i>
        <span>Log Sistema</span>
      </div>
      <!-- <div @click="push('/courtesy')" class="menu-item" :class="{ 'active' : isRoute('/courtesy') }">
        <i class="fas fa-gift"></i>
        <span>Cortesias</span>
      </div>
      <div @click="push('/producer')" class="menu-item" :class="{ 'active' : isRoute('/producer') }">
        <i class="fas fa-user-tie"></i>
        <span>Produtores</span>
      </div>
      <div @click="push('/settings')" class="menu-item" :class="{ 'active' : isRoute('/settings') }">
        <i class="fas fa-cog"></i>
        <span>Configurações</span>
      </div> -->
    </div>
    <div>
      <div @click="signOut" class="menu-item">
        <i class="fas fa-sign-out-alt"></i>
        <span>Sair</span>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { removeToken, loadModule } from '../../util'

export default {
  name: 'Menu',
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    async push (path) {
      this.open = false
      await this.$router.push(path)
    },
    isRoute (path) {
      if (this.$route.path.split('/')[1] === path.split('/')[1]) return true
      return false
    },
    signOut () {
      this.$store.commit('user', null)
      this.$root.$destroy()
      removeToken()
      // loadModule('main')
      this.$router.push('/')
      document.body.style.backgroundColor = '#1e1e1e'
      loadModule('main', 'redirect')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.menu-admin {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(50deg, $primary-color 0%, $secondary-color 100%);
  box-shadow: 0 1px 5px 0 rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12);
  color: #ffffff;
  z-index: 9;
  // padding: 10px 0 10px;
  padding-bottom: 10px;
  transition: height 0.3s;
  overflow-y: hidden;
  height: $menu-height;

  &.open {
    height: 100%;
  }
}

.menu-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: $menu-height;
  padding: 0 15px;
}

.menu-logo {
  cursor: pointer;
  // text-align: center;
  img {
    width: auto;
    height: 20px;
  }
}

.menu-icon {
  width: 30px;
  height: 30px;
  padding: 5px;
  cursor: pointer;
  text-align: right;
  i {
    font-size: 20px;
    line-height: 30px;
  }
}

.menu-items {
  flex-grow: 1;
}

.menu-item {
  font-size: 1.1em;
  font-weight: normal;
  padding: 8px 15px;
  cursor: pointer;
  i {
    width: 20px;
    text-align: center;
    margin-right: 10px;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.20);
  }
  &.active {
    background-color: rgba(0, 0, 0, 0.10);
  }
}

@media screen and (min-width: $desktop-width) {
  .menu-admin {
    width: $menu-width-open;
    height: 100%;
  }
  .menu-logo {
    flex-grow: 1;
  }
  .menu-icon {
    display: none;
  }
}

@media print {
  .menu-admin {
    display: none;
  }
}
</style>
